import { render, staticRenderFns } from "./ChartGroupDiscount.vue?vue&type=template&id=7e05d28c&scoped=true&"
import script from "./ChartGroupDiscount.vue?vue&type=script&lang=js&"
export * from "./ChartGroupDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e05d28c",
  null
  
)

export default component.exports